module.exports = __webpack_public_path__ + "static/media/bell-exclamation.9a84b3db.svg";